var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('AppToastArea'),(_vm.haveColorsBeenDefined)?[_c('v-main',[_c('router-view')],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }